/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SimpleReview
 */
export interface SimpleReview {
  /**
   *
   * @type {number}
   * @memberof SimpleReview
   */
  readonly id: number
  /**
   *
   * @type {number}
   * @memberof SimpleReview
   */
  rating?: number
  /**
   *
   * @type {string}
   * @memberof SimpleReview
   */
  author?: string | null
  /**
   *
   * @type {string}
   * @memberof SimpleReview
   */
  publishedAt?: string | null
  /**
   *
   * @type {boolean}
   * @memberof SimpleReview
   */
  isPublished?: boolean
  /**
   *
   * @type {string}
   * @memberof SimpleReview
   */
  text?: string | null
}

/**
 * Check if a given object implements the SimpleReview interface.
 */
export function instanceOfSimpleReview(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function SimpleReviewFromJSON(json: any): SimpleReview {
  return SimpleReviewFromJSONTyped(json, false)
}

export function SimpleReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleReview {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    rating: !exists(json, 'rating') ? undefined : json['rating'],
    author: !exists(json, 'author') ? undefined : json['author'],
    publishedAt: !exists(json, 'publishedAt') ? undefined : json['publishedAt'],
    isPublished: !exists(json, 'isPublished') ? undefined : json['isPublished'],
    text: !exists(json, 'text') ? undefined : json['text'],
  }
}

export function SimpleReviewToJSON(value?: SimpleReview | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    rating: value.rating,
    author: value.author,
    publishedAt: value.publishedAt,
    isPublished: value.isPublished,
    text: value.text,
  }
}
